import { Component, Prop, Vue } from "vue-property-decorator";
import WithRender from "./KPICards.html";
import { Inject } from "vue-di-container";
import RequestsOverviewService from "../RequestsOverviewService";

@WithRender
@Component({
  diProvide: [RequestsOverviewService],
})
export default class KPICards extends Vue {
  @Inject(RequestsOverviewService)
  public requestsOverviewService!: RequestsOverviewService;

  @Prop({ required: true }) public filter!: any;

  public isLoading: boolean = false;
  public hasData: boolean = true;
  private requestVersion: number = 0;

  public kpis: any = this.createEmptyKpis();

  public async refresh(): Promise<void> {
    if (!this.filter) {
      this.kpis = this.createEmptyKpis();
      return;
    }

    this.isLoading = true;
    const currentRequestVersion = ++this.requestVersion;

    const payload = {
      dateFrom: this.filter.dateFrom,
      dateTo: this.filter.dateTo,
      tenantId: this.filter.tenant,
      providerId: this.filter.providerId,
      customerType: this.filter.customerType,
      requestType: this.filter.requestType,
    };

    const res = await this.requestsOverviewService.GetKpis(payload);
    if (currentRequestVersion !== this.requestVersion) {
      return;
    }

    if (res) {
      this.kpis = {
        processedTotal: this.toNumber(res.processedTotal),
        withinSlaCount: this.toNumber(res.withinSlaCount),
        withinSlaPercent: this.toNumber(res.withinSlaPercent),
        exceededSlaCount: this.toNumber(res.exceededSlaCount),
        exceededSlaPercent: this.toNumber(res.exceededSlaPercent),
        approvalAvgBusinessDays: this.toNumber(res.approvalAvgBusinessDays),
        paymentAvgBusinessDays: this.toNumber(res.paymentAvgBusinessDays),
        activationAvgBusinessDays: this.toNumber(res.activationAvgBusinessDays),
      };
      this.hasData = this.kpis.processedTotal > 0;
    } else {
      this.kpis = this.createEmptyKpis();
      this.hasData = false;
    }

    this.isLoading = false;
  }

  private createEmptyKpis(): any {
    return {
      processedTotal: 0,
      withinSlaCount: 0,
      withinSlaPercent: 0,
      exceededSlaCount: 0,
      exceededSlaPercent: 0,
      approvalAvgBusinessDays: 0,
      paymentAvgBusinessDays: 0,
      activationAvgBusinessDays: 0,
    };
  }

  private toNumber(v: any): number {
    if (v === null || v === undefined || v === "") return 0;

    const n = Number(v);
    return isNaN(n) ? 0 : n;
  }

  public formatPercent(v: any): string {
    return this.toNumber(v).toFixed(0) + "%";
  }

  public formatDays(v: any): string {
    return this.toNumber(v).toFixed(1) + " " + String(this.$t("monitorDashboard.daysSuffix"));
  }

  public displayCount(v: any): string {
    return String(this.toNumber(v));
  }

}